import React from 'react';

const Pricing = () => {
  const plans = [
    {
      name: 'Starter',
      price: 'Coming Soon',
      description: 'Perfect for emerging fund managers',
      features: [
        'Up to 25 portfolio companies',
        'AI-powered due diligence',
        'Basic analytics & reporting',
        'Email support',
        'Data export capabilities'
      ],
      cta: 'Join Waitlist',
      highlighted: false
    },
    {
      name: 'Professional',
      price: 'Coming Soon',
      description: 'For established VC firms',
      features: [
        'Unlimited portfolio companies',
        'Advanced AI insights',
        'Real-time market intelligence',
        'Custom integrations',
        'Priority support',
        'Team collaboration tools',
        'API access'
      ],
      cta: 'Join Waitlist',
      highlighted: true
    },
    {
      name: 'Enterprise',
      price: 'Custom',
      description: 'For large organizations',
      features: [
        'Everything in Professional',
        'Dedicated account manager',
        'Custom AI models',
        'White-label options',
        'Advanced security & compliance',
        'Onboarding & training',
        'SLA guarantee'
      ],
      cta: 'Contact Sales',
      highlighted: false
    }
  ];

  return (
    <div style={{ minHeight: '100vh', padding: '120px 20px 80px', background: 'linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{ 
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#ede9fe',
            borderRadius: '24px',
            marginBottom: '24px'
          }}>
            <span style={{ color: '#7c3aed', fontSize: '14px', fontWeight: '600', letterSpacing: '0.5px' }}>
              PRICING
            </span>
          </div>
          <h1 style={{ 
            fontSize: '56px', 
            fontWeight: '800', 
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '24px',
            letterSpacing: '-1px',
            lineHeight: '1.1'
          }}>
            Simple, Transparent Pricing
          </h1>
          <p style={{ fontSize: '22px', color: '#6b7280', maxWidth: '700px', margin: '0 auto', lineHeight: '1.6' }}>
            Choose the plan that fits your needs. No hidden fees, no surprises.
          </p>
        </div>

        {/* Pricing Cards */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
          gap: '30px',
          marginBottom: '80px'
        }}>
          {plans.map((plan, index) => (
            <div 
              key={index}
              style={{
                backgroundColor: 'white',
                borderRadius: '16px',
                padding: '40px',
                border: plan.highlighted ? '3px solid #6366f1' : '1px solid #e5e7eb',
                position: 'relative',
                boxShadow: plan.highlighted ? '0 10px 40px rgba(99, 102, 241, 0.2)' : '0 4px 6px rgba(0, 0, 0, 0.05)',
                transform: plan.highlighted ? 'scale(1.05)' : 'scale(1)',
                transition: 'transform 0.3s ease'
              }}
            >
              {plan.highlighted && (
                <div style={{
                  position: 'absolute',
                  top: '-14px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  color: 'white',
                  padding: '8px 24px',
                  borderRadius: '24px',
                  fontSize: '13px',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: '0 4px 12px rgba(99, 102, 241, 0.4)'
                }}>
                  Most Popular
                </div>
              )}
              
              <h3 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '12px' }}>
                {plan.name}
              </h3>
              <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '24px' }}>
                {plan.description}
              </p>
              
              <div style={{ marginBottom: '30px' }}>
                <span style={{ fontSize: '48px', fontWeight: '700', color: '#1f2937' }}>
                  {plan.price}
                </span>
              </div>

              <ul style={{ marginBottom: '30px', listStyle: 'none', padding: 0 }}>
                {plan.features.map((feature, idx) => (
                  <li key={idx} style={{ 
                    padding: '12px 0', 
                    fontSize: '16px', 
                    color: '#4b5563',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <span style={{ color: '#10b981', marginRight: '12px', fontSize: '20px' }}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>

              <button style={{
                width: '100%',
                padding: '18px',
                background: plan.highlighted ? 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)' : 'white',
                color: plan.highlighted ? 'white' : '#6366f1',
                border: plan.highlighted ? 'none' : '2px solid #e5e7eb',
                borderRadius: '12px',
                fontSize: '17px',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: plan.highlighted ? '0 8px 20px rgba(99, 102, 241, 0.3)' : 'none'
              }}>
                {plan.cta}
              </button>
            </div>
          ))}
        </div>

        {/* FAQ Section */}
        <section style={{ maxWidth: '900px', margin: '0 auto 80px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <span style={{ 
              fontSize: '14px', 
              fontWeight: '700', 
              color: '#6366f1', 
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              FAQ
            </span>
            <h2 style={{ fontSize: '42px', fontWeight: '700', color: '#1f2937', marginTop: '16px' }}>
              Frequently Asked Questions
            </h2>
          </div>
          
          {[
            {
              q: 'When will pricing be available?',
              a: 'We\'re currently in beta and finalizing our pricing structure. Join the waitlist to be notified when we launch and receive exclusive early-bird pricing.'
            },
            {
              q: 'Do you offer a free trial?',
              a: 'Yes! All plans will come with a 14-day free trial. No credit card required.'
            },
            {
              q: 'Can I change plans later?',
              a: 'Absolutely. You can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle.'
            },
            {
              q: 'What payment methods do you accept?',
              a: 'We accept all major credit cards, wire transfers, and ACH payments for annual subscriptions.'
            }
          ].map((faq, index) => (
            <div key={index} style={{ 
              marginBottom: '20px', 
              padding: '32px', 
              backgroundColor: 'white', 
              borderRadius: '16px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.04)',
              transition: 'box-shadow 0.2s ease'
            }}>
              <h3 style={{ fontSize: '19px', fontWeight: '700', color: '#1f2937', marginBottom: '12px' }}>
                {faq.q}
              </h3>
              <p style={{ fontSize: '16px', color: '#6b7280', lineHeight: '1.7', margin: 0 }}>
                {faq.a}
              </p>
            </div>
          ))}
        </section>

        {/* Back to Home */}
        <div style={{ textAlign: 'center' }}>
          <a 
            href="/" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '14px 28px',
              color: '#6b7280',
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              fontWeight: '600',
              textDecoration: 'none',
              fontSize: '16px',
              transition: 'all 0.2s ease'
            }}
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
